import(/* webpackMode: "eager", webpackExports: ["ForeverPage"] */ "/vercel/path0/apps/store/src/app/[locale]/forever/[code]/ForeverPage.tsx");
